import { Controller } from "@hotwired/stimulus"

// Modal real basado en <dialog> nativo, cargado dentro del turbo-frame "modal".
// Cierra con ESC (nativo), clic en el fondo o botón de cierre.
export default class extends Controller {
  static values = { returnPath: String }

  connect() {
    if (typeof this.element.showModal === "function") this.element.showModal()
    this.element.addEventListener("close", this.onClose)
  }

  disconnect() {
    this.element.removeEventListener("close", this.onClose)
  }

  close() {
    this.element.close()
  }

  // Clic fuera del panel (sobre el propio <dialog>) = cerrar.
  backdrop(event) {
    if (event.target === this.element) this.element.close()
  }

  onClose = () => {
    const frame = document.getElementById("modal")
    if (frame) frame.innerHTML = ""
    // Si se llegó por enlace directo (URL de ticket), volver al tablero.
    if (window.location.pathname.startsWith("/portal/tickets/") && this.returnPathValue) {
      if (window.Turbo) window.Turbo.visit(this.returnPathValue)
      else window.location = this.returnPathValue
    }
  }
}
